// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZwqD","title":"Header_title__6cjsc","side":"Header_side__2g0lZ"};